import { render, staticRenderFns } from "./ShowDialog.vue?vue&type=template&id=24356f58"
import script from "./ShowDialog.vue?vue&type=script&lang=js"
export * from "./ShowDialog.vue?vue&type=script&lang=js"
import style0 from "./ShowDialog.vue?vue&type=style&index=0&id=24356f58&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ShowDialog.vue?vue&type=custom&index=0&blockType=meta&name=viewport&content=width%3Ddevice-width%2C%20initial-scale%3D1.0"
if (typeof block0 === 'function') block0(component)

export default component.exports